import apiClient from '../api';
import {
  PurchasePreferencesResponse,
  PurchaseSettings,
  CompoundPreference,
  ShowBudgetResponse,
  ShowBudgetItem,
  UpsertShowBudgetItem,
} from '../../types';

export const budgetService = {
  // ── Purchase Preferences ────────────────────────────────────────────────────

  /** Get all saved purchase preferences (compound settings + order defaults) */
  getPreferences: async (): Promise<PurchasePreferencesResponse> => {
    const response = await apiClient.get('/budget/preferences');
    return response.data;
  },

  /** Save order-level settings (buffer %, tax %, shipping) */
  saveSettings: async (settings: PurchaseSettings): Promise<PurchaseSettings> => {
    const response = await apiClient.put('/budget/preferences/settings', settings);
    return response.data;
  },

  /** Save per-compound preferences (concentration, vial size, price) */
  saveCompoundPreference: async (pref: {
    compoundId: string;
    concentrationMgPerMl: number;
    vialSizeMl: number;
    pricePerVial: number;
  }): Promise<CompoundPreference> => {
    const response = await apiClient.put('/budget/preferences/compound', pref);
    return response.data;
  },

  // ── Show Budget ─────────────────────────────────────────────────────────────

  /** Get all budget items for a show */
  getShowBudget: async (showId: string): Promise<ShowBudgetResponse> => {
    const response = await apiClient.get(`/budget/show/${showId}`);
    return response.data;
  },

  /** Create or update a budget line item (DrugLoad items upsert by cycleId) */
  upsertBudgetItem: async (showId: string, item: UpsertShowBudgetItem): Promise<ShowBudgetItem> => {
    const response = await apiClient.put(`/budget/show/${showId}/item`, item);
    return response.data;
  },

  /** Delete a budget line item */
  deleteBudgetItem: async (showId: string, itemId: string): Promise<void> => {
    await apiClient.delete(`/budget/show/${showId}/item/${itemId}`);
  },
};
